import { useTranslation } from 'react-i18next';
import { File as FileIcon } from 'lucide-react';
import { Button } from '../../ui/button';
import { cn } from '../../../lib/utils';
import {
    linkedRowClass,
    linkedNameClass,
    linkedMetaClass,
} from '../../ui-components/linkedItemStyles';
import { useFilePreview } from './useFilePreview';
import { LinkedFileDTO } from '../../../services/apiService';

interface AttachedFileRowProps {
    file: LinkedFileDTO;
}

export default function AttachedFileRow({ file }: AttachedFileRowProps) {
    const { t } = useTranslation();
    const { open, opening, previewable, modal } = useFilePreview(file);
    const extension = file.filename.split('.').pop()?.toUpperCase();

    return (
        <div className={linkedRowClass}>
            <FileIcon
                className="h-4 w-4 shrink-0 text-subtle-foreground"
                aria-hidden="true"
            />
            <span className={cn(linkedNameClass, 'text-blue')}>
                {file.filename}
            </span>
            {extension && <span className={linkedMetaClass}>{extension}</span>}
            <Button
                type="button"
                variant="ghost"
                size="sm"
                className="h-7 shrink-0 px-2 text-xs"
                disabled={opening}
                onClick={open}
            >
                {t(
                    previewable
                        ? 'roomOverview.machineDetail.preview'
                        : file.documentType === 'other'
                          ? 'roomOverview.machineDetail.download'
                          : 'roomOverview.machineDetail.open'
                )}
            </Button>
            {modal}
        </div>
    );
}
